import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ClientField } from '@1po/1po-bff-fe-spec/generated/estimate/request/UpdateClient';
import { RootState } from 'app/AppStore';
import { getEstimateClient, updateClient } from 'domains/estimate/Estimate.store';
import { LightCard } from 'UI';
import { SClientGrid, SInput } from './ClientSection.styled';

export interface ClientSectionProps {
  estimateId: string;
}

const ClientSection = ({ estimateId }: ClientSectionProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const client = useSelector((state: RootState) => getEstimateClient(state, estimateId));
  const name = client?.name || '';
  const phoneNumber = client?.phoneNumber || '';
  const email = client?.email || '';
  const street = client?.street || '';
  const postalCode = client?.postalCode || '';
  const city = client?.city || '';

  const handleUpdate = (field: ClientField) => (newValue: string) => {
    dispatch(updateClient({ field, newValue }));
  };

  return (
    <LightCard title={t('estimate.client_contact', 'Client contact')}>
      <SClientGrid>
        <SInput
          id={'estimate-client-contact-id'}
          name={'estimate-client-contact-name'}
          autoComplete={'on'}
          initialValue={name}
          onChangeDebounced={handleUpdate('NAME')}
          placeholder={t('common.name', 'Name')}
          bordered
          ellipsis
        />
        <SInput
          initialValue={email}
          onChangeDebounced={handleUpdate('EMAIL')}
          placeholder={t('common.email', 'E-mail address')}
          bordered
          ellipsis
        />
        <SInput
          initialValue={phoneNumber}
          onChangeDebounced={handleUpdate('PHONE')}
          placeholder={t('common.phone_number', 'Phone number')}
          bordered
          ellipsis
        />
        <SInput
          initialValue={street}
          onChangeDebounced={handleUpdate('STREET')}
          placeholder={t('estimate.client_contact.postal_address', 'Postal address')}
          maxLength={250}
          bordered
          ellipsis
        />
        <SInput
          initialValue={postalCode}
          onChangeDebounced={handleUpdate('POSTAL_CODE')}
          placeholder={t('estimate.client_contact.postal_code', 'Postal code')}
          maxLength={10}
          bordered
          ellipsis
        />
        <SInput
          initialValue={city}
          onChangeDebounced={handleUpdate('CITY')}
          placeholder={t('estimate.client_contact.city', 'City')}
          maxLength={100}
          bordered
          ellipsis
        />
      </SClientGrid>
    </LightCard>
  );
};

export default ClientSection;
